import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Classes from "./Integrations.module.css";
import Sidebar from "./Components/Sidebar/Sidebar";
import All from "./Components/All/All";

const LeftArrow = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 448 512">
        <path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z" />
    </svg>
);

export default function Integrations() {
    const navigateTo = useNavigate();
    const [activeTab, setActiveTab] = useState("all");

    return (
        <div className={Classes.container}>
            <div className={Classes.header}>
                <div>
                    <h3>Integrations</h3>
                    <h5>Manage your account integrations.</h5>
                </div>
            </div>
            {/* <button onClick={() => navigateTo("/clients")} className={Classes.backButton}>
                    <LeftArrow height='12px' fill='#969696' />
                    <h5>Integrations</h5>
                </button> */}
            <div className={Classes.hero} >
                <div style={{ marginBottom: '2rem' }} >
                    <h3>Integrations</h3>
                </div>
                <div className={Classes.grid} >
                    <div className={Classes.gridLeft}>
                        <Sidebar activeTab={activeTab} setActiveTab={setActiveTab} />
                    </div>
                    <div className={Classes.gridRight} >
                        {activeTab === "all" && <All />}
                    </div>
                </div>
            </div>

        </div >
    );
}